const SvgMinus2 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 30 2">
    <path fill="#373737" fillRule="evenodd" d="M30 .167H0v1.666h30z" clipRule="evenodd" />
  </svg>;
export default SvgMinus2;